export default __webpack_public_path__ + "static/media/microsoft-excel.d53be407.svg";